import React, { useState, useEffect } from "react";
import api from "../../../../utils/api";
import { toast } from "react-toastify";

const ManageTimingModal = ({ isOpen, onClose }) => {
  const [timings, setTimings] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchTimings();
    }
  }, [isOpen]);

  const fetchTimings = async (showLoading = true) => {
    try {
      if (showLoading) setLoading(true);
      const res = await api.get("/menu-timings");
      setTimings(res.data.data);
    } catch (error) {
      toast.error("Failed to fetch timings");
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  const handleTimingChange = (index, field, value) => {
    const updated = [...timings];
    updated[index][field] = value;
    setTimings(updated);
  };

  const handleSave = async (timing) => {
    try {
      await api.put(`/menu-timings/${timing._id}`, {
        name: timing.name,
        startTime: timing.startTime,
        endTime: timing.endTime
      });
      toast.success(`${timing.name} updated successfully!`);
      // Re-fetch to ensure sync after save without triggering loading screen
      fetchTimings(false);
    } catch (error) {
       toast.error("Failed to save timing");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]">
        <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100">
          <h2 className="text-xl font-bold border-l-4 border-blue-500 pl-3">
            Manage Product Timings
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-red-50"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto pr-2 space-y-4">
          {loading ? (
             <div className="text-center py-4">Loading...</div>
          ) : (
            timings.map((timing, idx) => (
              <div key={timing._id || idx} className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="flex justify-between items-center mb-3">
                   <h3 className="font-semibold text-gray-800">{timing.name}</h3>
                   <button 
                     onClick={() => handleSave(timing)}
                     className="text-sm bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded shadow-sm"
                   >
                     Save
                   </button>
                </div>
                <div className="flex items-center gap-4">
                  <div className="flex-1">
                    <label className="block text-xs font-medium text-gray-500 mb-1">Start Time</label>
                    <input 
                      type="time" 
                      value={timing.startTime}
                      onChange={(e) => handleTimingChange(idx, "startTime", e.target.value)}
                      className="w-full text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 p-2 border" 
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-xs font-medium text-gray-500 mb-1">End Time</label>
                    <input 
                      type="time" 
                      value={timing.endTime}
                      onChange={(e) => handleTimingChange(idx, "endTime", e.target.value)}
                      className="w-full text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 p-2 border" 
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageTimingModal;
